import styled from 'styled-components';

import { Component as MainTemplate } from '../MainTemplate';

export const ErrorTemplate = styled(MainTemplate)`
  main {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
